import React from 'react';
import PropTypes from 'prop-types';
import PageCard from './PageCard';

const SheetPair = ({
  frontPages,
  backPages,
  frontThumbnails = [],
  backThumbnails = [],
  showPageNumbers,
  showHoleGuides,
  showFoldLine,
  pageTransforms = null,
  showPageImages = true,
  showOutputPageNumbers = false,
  pageNumberOffset = 0,
  pageNumberFontSize = 12
}) => (
  <div className="page-pair">
    <PageCard
      pageNumbers={frontPages}
      isBlank={frontPages.every(num => num === 0)}
      orientation="landscape"
      showDebugNumbers={showPageNumbers}
      showGuides={showHoleGuides || showFoldLine}
      showHoleGuides={showHoleGuides}
      showFoldLine={showFoldLine}
      thumbnails={frontThumbnails}
      thumbnailTransforms={pageTransforms}
      showPageImages={showPageImages}
      showOutputPageNumber={showOutputPageNumbers}
      pageNumberOffset={pageNumberOffset}
      pageNumberFontSize={pageNumberFontSize}
    />
    <PageCard
      pageNumbers={backPages}
      isBlank={backPages.every(num => num === 0)}
      orientation="landscape"
      showDebugNumbers={showPageNumbers}
      showGuides={showHoleGuides || showFoldLine}
      showHoleGuides={showHoleGuides}
      showFoldLine={showFoldLine}
      thumbnails={backThumbnails}
      thumbnailTransforms={pageTransforms}
      showPageImages={showPageImages}
      showOutputPageNumber={showOutputPageNumbers}
      pageNumberOffset={pageNumberOffset}
      pageNumberFontSize={pageNumberFontSize}
    />
  </div>
);

SheetPair.propTypes = {
  frontPages: PropTypes.arrayOf(PropTypes.number).isRequired,
  backPages: PropTypes.arrayOf(PropTypes.number).isRequired,
  frontThumbnails: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf([null])
    ])
  ),
  backThumbnails: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.oneOf([null])
    ])
  ),
  showPageNumbers: PropTypes.bool,
  showHoleGuides: PropTypes.bool,
  showFoldLine: PropTypes.bool,
  pageTransforms: PropTypes.shape({
    left: PropTypes.object,
    right: PropTypes.object,
  }),
  showPageImages: PropTypes.bool,
  showOutputPageNumbers: PropTypes.bool,
  pageNumberOffset: PropTypes.number,
  pageNumberFontSize: PropTypes.number
};

export default SheetPair; 
